// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"361": "8be16b8f0c23a558","448": "d9e7cc89842b878f",}[chunkId] + ".js"
}